<template>
<div>
  <div class="input-group input-group-sm">
    <input type="search" class="form-control search-input-field" ref="input"
      v-model="keyword" @keydown.enter="onEnter" :placeholder="`${title} filtern ...`"
      @input="onChange" @keyup.down="onArrowDown" @keyup.up="onArrowUp">
    <ul class="autocomplete-results" v-show="isOpen">
      <li class="autocomplete-result"
        v-for="(result, i) in results"
        :key="i" @click="setResults(result)"
        :class="{ 'is-active': i === arrowCounter }"> {{ result }}
      </li>
    </ul>
  </div>
  <b-btn class="btn btn-sm btn-block" style="margin-top: 2px;" @click="search"> Anwenden </b-btn>
  <b-btn class="btn btn-sm btn-block" style="margin-top: 2px;" @click="deleteFilter"> Filter zurücksetzen </b-btn>
</div>
</template>

<script>
import filterMixins from './filter-mixins'

export default {
  name: 'text-filter',
  mixins: [filterMixins],
  data () {
    return {
      keyword: ''
    }
  },
  methods: {
    setOptions () {
      var setFilter = this.query.freeTextFilters[this.field]
      this.keyword = setFilter || ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/plugins/textFilter.vue